import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import FormItem from '../../components/form/FormItem'
import { MdTitle } from 'react-icons/md'
import { BiX } from 'react-icons/bi'
import { Button, Form } from 'reactstrap'
import { fetchPageGet } from '../../redux/slices/pageGetSlice'
import { fetchPageCreate } from '../../redux/slices/pageCreateSlice'
import { fetchPageUpdate } from '../../redux/slices/pageUpdateSlice'
import { ToSeoUrl } from '../../components/general/SeoUrl'

const CrudPage = ({ showMenu, setShowMenu, setChanged, setSelectedItem, selectedItem, t, getAllData }) => {
    const [formData, setFormData] = useState({ files: [] })
    const dispatch = useDispatch()

    const getData = async () => {
        if (selectedItem !== 0) {
            var data = await dispatch(fetchPageGet({ id: selectedItem }))
            if (data.payload) {
                setFormData({
                    files: data.payload?.files,
                    titletr: data.payload?.title["tr"],
                    titleen: data.payload?.title["en"],
                })
            }
        }
    }

    const closeModal = () => {
        setFormData({ files: [], titletr: "", titleen: "" })
        setShowMenu(!showMenu)
        setSelectedItem(0)
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        const title = { "tr": formData.titletr, "en": formData.titleen }
        const slug = { "tr": formData.slugtr, "en": formData.slugen }
        const description = {}
        const content = {}

        await dispatch(
            selectedItem === 0 ?
                fetchPageCreate({ title: title, slug: slug, description: description, content: content }) :
                fetchPageUpdate({ id: selectedItem, title: title, slug: slug, description: description, content: content })
        )
        setFormData({ files: [], slugtr: "", slugen: "", titletr: "", titleen: "" })
        getAllData()
        closeModal()
        setChanged(true)
        getData()
        setShowMenu(false)
    }

    useEffect(() => { getData() }, [dispatch, selectedItem])

    return (
        <div className={showMenu ? 'right-popup' : 'd-none'}>
            <div className='right-popup-close' onClick={closeModal}><BiX size={24} /></div>
            <div className='right-popup-menu'>
                <div className='mb-3 text-center'><h5>{t(selectedItem === 0 ? "page_add" : "page_edit")}</h5></div>
                <Form onSubmit={handleSubmit}>
                    <FormItem
                        id={`titletr`}
                        name={`titletr`}
                        type="text"
                        icon={<MdTitle size={20} />}
                        title={`${t("title")} (TR)`}
                        formData={formData}
                        setFormData={setFormData}
                        keyT='titletr'
                        onChange={() => setFormData(prev => ({ ...prev, slugtr: ToSeoUrl(prev.titletr) }))}
                    />
                    <FormItem
                        id={`slugtr`}
                        name={`slugtr`}
                        type="text"
                        icon={<MdTitle size={20} />}
                        title={`${t("slug")} (TR)`}
                        formData={formData}
                        setFormData={setFormData}
                        keyT='slugtr'
                    />
                    <FormItem
                        id={`titleen`}
                        name={`titleen`}
                        type="text"
                        icon={<MdTitle size={20} />}
                        title={`${t("title")} (EN)`}
                        formData={formData}
                        setFormData={setFormData}
                        keyT='titleen'
                        onChange={() => setFormData(prev => ({ ...prev, slugen: ToSeoUrl(prev.titleen) }))}
                    />
                    <FormItem
                        id={`slugen`}
                        name={`slugen`}
                        type="text"
                        icon={<MdTitle size={20} />}
                        title={`${t("slug")} (EN)`}
                        formData={formData}
                        setFormData={setFormData}
                        keyT='slugen'
                    />

                    <div className='d-flex justify-content-end mt-4 w-100'>
                        <Button type='submit' color={selectedItem === 0 ? 'primary' : 'warning'} className="text-white">
                            {t(selectedItem === 0 ? "add" : "edit")}
                        </Button>
                    </div>
                </Form>
            </div>
        </div>
    )
}

export default CrudPage